import { useState, useCallback, useEffect } from "react";

import { config } from "../../config";
import { useHttpClient } from "../Hooks/http-hook";

const useStores = () => {
    const [stores, setStores] = useState([]);
    const [usersType, setUsersType] = useState("registered");
    const [isUpdatedStores, setIsUpdatedStores] = useState(false);
    const [HideStoresSkeleton, setHideStoresSkeleton] = useState(false);
    const [storeListPosition, setStoreListPosition] = useState(0);
    const { error, sendRequest, clearError } = useHttpClient();

    const updateStores = (stores) => {
        setStores(stores);
        setIsUpdatedStores(true);
    };

    const removeReq = (email) => {
        setStores(
            stores.filter((item) =>
                (item.email !== email)
            )
        );
    }

    const fetchStores = useCallback(async (token) => {
        try {
            const responseData = await sendRequest(
                `${config.API_URL}/users/stores`,
                'GET',
                null,
                {
                    Authorization: 'Bearer ' + token
                }
            );
            clearError();
            updateStores(responseData);
            return responseData
        } catch (err) {
            setIsUpdatedStores(true);
            console.error(err);
        }
    }, [sendRequest, updateStores, setIsUpdatedStores, clearError]);


    const fetchUnregisteredStores = useCallback(async (token) => {
        try {
            const responseData = await sendRequest(
                `${config.API_URL}/join/`,
                'GET',
                null,
                {
                    Authorization: 'Bearer ' + token
                }
            );
            clearError();
            updateStores(responseData);
            return responseData
        } catch (err) {
            setIsUpdatedStores(true);
            console.error(err);
        }
    }, [sendRequest, updateStores, setIsUpdatedStores, clearError]);

    const fetchStore = useCallback(async (token, storeId) => {
        try {
            const responseData = await sendRequest(
                `${config.API_URL}/users/store/${storeId}`,
                'GET',
                null,
                {
                    Authorization: 'Bearer ' + token
                }
            );
            clearError();
            setStores((prevStores) => [responseData, ...prevStores]);
        } catch (err) {
            setIsUpdatedStores(true);
            console.error(err);
        }
    }, [sendRequest, updateStores, setIsUpdatedStores, clearError, setStores]);

    const removeStores = useCallback(()=> {
        setStores([]);
        setIsUpdatedStores(false);
        setHideStoresSkeleton(false);
        setStoreListPosition(0);
        setUsersType("registered")
    },[setStores, setIsUpdatedStores, setHideStoresSkeleton, setStoreListPosition]);

    const getStoreRecordId = (store) => store?.id || store?._id;

    const updateStore = useCallback((updatedStore, storeId) => {
        const resolvedStoreId = storeId || getStoreRecordId(updatedStore);

        setStores((prevStores) => prevStores.map((store) => {
            const currentStoreId = getStoreRecordId(store);
            const isSameStore = (resolvedStoreId && currentStoreId === resolvedStoreId)
                || (updatedStore?.username && store.username === updatedStore.username);

            return isSameStore ? updatedStore : store;
        }));
    }, [setStores]);

    const handleStoreListPosition = useCallback((position)=>{
        setStoreListPosition(position);
    },[setStoreListPosition]);

    useEffect(() => {
        removeStores();
    }, []);

    return {
        stores,
        isUpdatedStores,
        fetchStores,
        fetchStore,
        updateStore,
        HideStoresSkeleton,
        setHideStoresSkeleton,
        removeStores,
        StoresError: error,
        storeListPosition,
        handleStoreListPosition,
        setStoreListPosition,
        fetchUnregisteredStores,
        usersType,
        setUsersType,
        removeReq,
    };
}

export default useStores;